import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TranslationService from "./../../Services/translationService";
import { withRouter } from "react-router";
import _InfoSvg from "./../../Components/Svg/_infoSvg";
import PageInfoBlock from "./../../Components/PageInfoBlock/PageInfoBlock";
import { Card, Tab, Table, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import MessagesForm from "./Components/MessagesForm";
import ImagesForm from "./Components/ImagesForm";
import PromptForm from "./Components/PromptForm";
import ColorForm from "./Components/ColorForm";
import {
	addPartialViewSpinner,
	removePartialViewSpinner,
} from "../../Store/Actions/spinner";
import uuid from "react-uuid";
import ApiService from "../../Services/apiService";
import { setSettings } from "../../Store/Actions/settings";
import AlertService from "../../Services/alertService";
import { ERROR_KEY } from "../../Constants/mainKeys";

const Settings = props => {
	const dispatch = useDispatch();
	const { history } = props;
	const { translations } = useSelector(state => state.translation);
	const { language } = useSelector(state => state.language);
	const [translationService, setTranslationService] = useState(null);
	const { settings } = useSelector(state => state.settings);
	const { user } = useSelector(state => state.user);

	// useEffect(() => {
	// 	if (!settings && user) {
	// 		const spinnerId = uuid();
	// 		dispatch(addPartialViewSpinner(spinnerId));
	// 		ApiService.getSetting()
	// 			.then(res => {
	// 				if (res.data) {
	// 					dispatch(setSettings(res.data));
	// 				}
	// 			})
	// 			.catch(error => {
	// 				AlertService.alert(
	// 					AlertService.checkMessageType(error.respcode) || ERROR_KEY,
	// 					error,
	// 				);
	// 			})
	// 			.finally(() => {
	// 				dispatch(removePartialViewSpinner(spinnerId));
	// 			});
	// 	}
	// }, []);

	const [key, setKey] = useState("1");

	useEffect(() => {
		setTranslationService(new TranslationService(translations));
	}, [translations]);

	return translationService ? (
		<div className="container">
			<div className="row mt-4">
				<div className="col-12">
					<h2 className="section-title">Settings</h2>
					<PageInfoBlock
						pageTitle="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
						infoText="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
						translationService={translationService}
					/>
				</div>
			</div>
			<hr />
			<div className="row">
				<div className="col-12">
					<Tabs
						activeKey={key}
						className={`setting-tabs`}
						onSelect={newKey => {
							if (
								settings &&
								settings.organizationShortName &&
								key !== newKey
							) {
								setKey(newKey);
							}
						}}>
						<Tab eventKey="1" title={"Messages"}>
							<MessagesForm setKey={setKey} eventKey={2} />
						</Tab>
						<Tab eventKey="2" title={"Images"}>
							<ImagesForm setKey={setKey} eventKey={4} />
						</Tab>
						{/* <Tab eventKey="3" title={"Prompt"}>
							<PromptForm setKey={setKey} eventKey={3} />
						</Tab> */}
						<Tab eventKey="4" title={"Color"}>
							<ColorForm />
						</Tab>
					</Tabs>
				</div>
			</div>
		</div>
	) : null;
};

export default withRouter(Settings);
